import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavComponent } from '../../core/shared/components/nav/nav.component';

@Component({
  selector: 'app-developer',
  templateUrl: './developer.component.html',
  styleUrls: ['./developer.component.scss'],
  standalone: true,
  imports: [NavComponent, RouterOutlet],
})
export class DeveloperComponent {}
